/**
 * Chip для одной цитаты (Сигнал / Развилка / Премисса) на узле
 * NarrativeBlock'а. Компактный, по клику раскрывается inline-карточкой
 * (на этой фазе — пока только показ summary, без drilldown в полную
 * сущность; полный drawer добавится в следующей итерации).
 */

import { Badge, Group, Text } from '@mantine/core';
import type { Citation } from '@pflow/shared/v2';

const EMOJI: Record<Citation['kind'], string> = {
    signal:   '📡',
    decision: '🔀',
    premise:  '⚖️',
};

const COLOR: Record<Citation['kind'], string> = {
    signal:   'blue',
    decision: 'grape',
    premise:  'orange',
};

export function CitationChip({ citation }: { citation: Citation }): JSX.Element {
    return (
        <Badge
            variant="light"
            color={COLOR[citation.kind]}
            size="sm"
            leftSection={<Text span fz="xs">{EMOJI[citation.kind]}</Text>}
            title={`${citation.ref.type} «${citation.ref.name}»: ${citation.summary}`}
            // `display:inline-flex` + `maxWidth: 100%` — на mobile chip сжимается
            // до ширины контейнера, не выскакивает на новую строку странным
            // одиноким элементом и не вылезает за карточку.
            style={{
                textTransform: 'none',
                fontWeight: 400,
                maxWidth: '100%',
                overflow: 'hidden',
            }}
        >
            <Group gap={4} wrap="nowrap" style={{ maxWidth: 280, overflow: 'hidden' }}>
                <Text span fz="xs" fw={500} truncate>«{citation.ref.name}»</Text>
                <Text span fz="xs" c="dimmed" truncate>{citation.summary}</Text>
            </Group>
        </Badge>
    );
}

export function CitationList({ citations }: { citations: Citation[] }): JSX.Element | null {
    if (citations.length === 0) return null;
    return (
        <Group gap={4} wrap="wrap" mt={4}>
            {citations.map((c, i) => <CitationChip key={i} citation={c} />)}
        </Group>
    );
}
